import { Box, Typography, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate, useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { apiBase } from '../../services/apiBase'
import { api } from '../../utils/api'
import UserLayout from '../../layouts/UserLayout'

const OrderDetail = () => {
	const navigate = useNavigate()
	const [orderDetail, setOrderDetail] = useState(null)
	const { orderId } = useParams()

	useEffect(() => {
		const fetchOrderDetail = async () => {
			try {
				const response = await apiBase.get(`${api.GET_ORDER_DETAIL}?orderId=${orderId}`)
				if (response?.order?.order) {
					setOrderDetail(response.order.order)
				}
			} catch (error) {
				console.error('Error fetching order detail:', error)
			}
		}

		fetchOrderDetail()
	}, [orderId])

	return (
		<UserLayout>
			<Box sx={{ background: '#f5f5f5', minHeight: '100vh' }}>
				{/* Header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						p: 2,
						background: '#fff',
						borderBottom: '1px solid #e0e0e0',
						position: 'sticky',
						top: 0,
						zIndex: 1000,
					}}>
					<IconButton onClick={() => navigate(-1)} sx={{ color: '#000' }}>
						<ArrowBackIcon />
					</IconButton>
					<Typography
						sx={{
							fontSize: '20px',
							fontWeight: 500,
							flex: 1,
							textAlign: 'left',
						}}>
						Chi tiết đơn hàng
					</Typography>
				</Box>

				{orderDetail && (
					<Box sx={{ p: 2 }}>
						{/* Order Status */}
						<Box
							sx={{
								background: '#00AB55',
								color: 'white',
								p: 2,
								borderRadius: '8px 8px 0 0',
							}}>
							<Typography sx={{ fontSize: '18px' }}>
								Đơn hàng - {orderDetail.status === 'completed' ? 'Hoàn thành đơn hàng' : orderDetail.status}
							</Typography>
						</Box>

						{/* Order Info */}
						<Box
							sx={{
								background: '#fff',
								p: 2,
								borderRadius: '0 0 8px 8px',
								mb: 2,
							}}>
							<Typography sx={{ fontSize: '16px', wordBreak: 'break-word', overflowWrap: 'break-word', mb: 1 }}>
								Mã đơn hàng: {orderDetail.id}
							</Typography>
							<Typography sx={{ fontSize: '14px', color: '#666', mb: 2 }}>
								Ngày tạo: {orderDetail.date_created}
							</Typography>

							<Typography sx={{ fontSize: '16px', fontWeight: 500, mb: 1 }}>Giao hàng tận nơi</Typography>
							<Typography sx={{ fontSize: '14px', mb: 0.5 }}>
								{orderDetail.customer_name} {orderDetail.customer_phone}
							</Typography>
							<Typography sx={{ fontSize: '14px', color: '#666', mb: 1 }}>{orderDetail.shipping?.address}</Typography>
							<Typography sx={{ fontSize: '14px', color: '#666' }}>
								Thời gian giao hàng: {orderDetail.shippingDate?.hour}:{orderDetail.shippingDate?.minute} ngày{' '}
								{orderDetail.shippingDate?.date}
							</Typography>
						</Box>

						{/* Store and Products */}
						<Box
							sx={{
								background: '#fff',
								p: 2,
								borderRadius: '8px',
								mb: 2,
							}}>
							<Typography sx={{ fontSize: '16px', fontWeight: 500, mb: 2 }}>
								{orderDetail.cua_hang?.[0]?.name}
							</Typography>

							{orderDetail.line_items?.map((item, index) => (
								<Box key={index} sx={{ display: 'flex', gap: 2, mb: 2 }}>
									<Box
										component='img'
										src={item.image}
										sx={{
											width: 80,
											height: 80,
											objectFit: 'cover',
											borderRadius: '4px',
										}}
									/>
									<Box sx={{ flex: 1 }}>
										<Typography sx={{ fontSize: '16px', mb: 1 }}>{item.name}</Typography>
										<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
											<Typography sx={{ fontSize: '14px', color: '#666' }}>x{item.quantity}</Typography>
											<Typography sx={{ fontSize: '16px' }}>{item.price?.toLocaleString()}đ</Typography>
										</Box>
									</Box>
								</Box>
							))}

							{/* Payment Summary */}
							<Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
								<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
									<Typography sx={{ fontSize: '14px', color: '#666' }}>Tổng tiền hàng:</Typography>
									<Typography sx={{ fontSize: '14px' }}>{orderDetail.total_item?.toLocaleString()}đ</Typography>
								</Box>
								<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
									<Typography sx={{ fontSize: '14px', color: '#666' }}>Phí vận chuyển:</Typography>
									<Typography sx={{ fontSize: '14px' }}>{orderDetail.shipping_total?.toLocaleString()}đ</Typography>
								</Box>
								<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
									<Typography sx={{ fontSize: '14px', color: '#666' }}>Điểm sử dụng:</Typography>
									<Typography sx={{ fontSize: '14px' }}>{orderDetail.useScore ? '1.000đ' : '0đ'}</Typography>
								</Box>
								<Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
									<Typography sx={{ fontSize: '16px' }}>Thành tiền (COD):</Typography>
									<Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#00AB55' }}>
										{orderDetail.total?.toLocaleString()}đ
									</Typography>
								</Box>
							</Box>
						</Box>
					</Box>
				)}
			</Box>
		</UserLayout>
	)
}

export default OrderDetail
